import _ from "lodash";
import {getSubSystemConfigItem} from "../../../../../../../utils/utils";
import {
  ORDERING_AVAILABLE_OPTIONS_FIELD_NAMES,
  ORDERING_MP_AVAILABLE_OPTIONS_FIELD_NAMES,
  SERVICE_CONCEPTS,
  TRANSACTION_TYPE_VALUES,
} from "../../../../../constants";
import {portfolioHasTransactions} from "../../../CombinedTradeStepV2";


/**
 * Hook that derives portfolio configuration values from props/flags.
 * Centralizes all the conditional logic around isVirtual, isModelportfolio, isPassiveDepot, etc.
 */
const usePortfolioConfig = ({portfolio, isVirtual, isNewVirtual, showSectionsWithoutTransactions, allowedTradeOptions: propsAllowedTradeOptions, dataService}) => {

  const isPassiveDepot = _.get(portfolio, 'data.is_passive');
  const isAnlageberatung = dataService.serviceConcept == SERVICE_CONCEPTS.Anlageberatung;

  const allowedTradeOptions = (() => {
    const defaultOptions = () => {
      return [TRANSACTION_TYPE_VALUES.BUY, TRANSACTION_TYPE_VALUES.SELL, TRANSACTION_TYPE_VALUES.SWITCH];
    };

    const options = isPassiveDepot
      ? [TRANSACTION_TYPE_VALUES.SELL]
      : propsAllowedTradeOptions || defaultOptions();

    if (showSectionsWithoutTransactions) {
      return options;
    }

    return _.filter(options, (option) => portfolioHasTransactions(portfolio, [option]));
  })();

  const quotationFieldsSource = portfolio.isModelportfolio
    ? ORDERING_MP_AVAILABLE_OPTIONS_FIELD_NAMES
    : ORDERING_AVAILABLE_OPTIONS_FIELD_NAMES;

  const portfolioType = (() => {
    if (portfolio.isModelportfolio) return 'model_portfolio';
    if (!isVirtual) return 'real';
    return isNewVirtual ? 'virtual_create' : 'virtual';
  })();

  const predefinedFilter = isVirtual
    ? {}
    : {cCustodian: [{label: portfolio.custodianName, id: portfolio.companyId, value: portfolio.companyId}]};

  return {
    isPassiveDepot,
    isAnlageberatung,
    allowedTradeOptions,
    quotationFieldsSource,
    portfolioType,
    predefinedFilter,
  };
};

export default usePortfolioConfig;
